module.exports = __webpack_public_path__ + "static/media/dinners.c0e99eb0.svg";